import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { Id } from "@/convex/_generated/dataModel";
import ProductForm from "@/components/products/product-create-update/product-form";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute(
  "/_authenticated/products/_layout/$id/edit",
)({
  component: EditProductPage,
});

function EditProductPage() {
  const { id } = Route.useParams();

  const product = useQuery(api.companies.products.queries.getProductService, {
    id: id as Id<"products">,
  });

  if (product === undefined) {
    return (
<RouteGuardPermissions
      permissions={[{ module: "products", actions: ["read", "update"] }]}>
      
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    
    </RouteGuardPermissions>
    );
  }

  if (product === null) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-muted-foreground">Producto no encontrado</p>
      </div>
    );
  }

  return <ProductForm product={product} />;
}
